import { useEffect, useRef, useState } from "react";

const PROJECT_CHAT_REALTIME_EVENT = "project-chat-realtime";

export default function useProjectLiveChatRealtime({ enabled, userId, onUpdate, onSubscribed }) {
  const [status, setStatus] = useState("disabled");
  const onUpdateRef = useRef(onUpdate);
  const onSubscribedRef = useRef(onSubscribed);

  useEffect(() => {
    onUpdateRef.current = onUpdate;
    onSubscribedRef.current = onSubscribed;
  }, [onUpdate, onSubscribed]);

  useEffect(() => {
    if (!enabled || !userId) {
      setStatus("disabled");
      return undefined;
    }

    const handleProjectChatUpdate = (browserEvent) => {
      const event = browserEvent?.detail;
      const projectId = Number(event?.project_id);
      const messageId = Number(event?.message_id);

      if (!Number.isInteger(projectId) || projectId <= 0) return;

      onUpdateRef.current?.({
        projectId,
        messageId: Number.isInteger(messageId) && messageId > 0 ? messageId : null,
        notify: event?.notify !== false,
        autoOpen: event?.auto_open === true,
      });
    };

    window.addEventListener(PROJECT_CHAT_REALTIME_EVENT, handleProjectChatUpdate);
    setStatus("connected");

    // Visible row badges take one batched recovery snapshot when this listener
    // becomes ready. All later changes arrive through the existing Echo relay.
    onSubscribedRef.current?.();

    return () => {
      window.removeEventListener(PROJECT_CHAT_REALTIME_EVENT, handleProjectChatUpdate);
    };
  }, [enabled, userId]);

  return status;
}
